// Helpers para tratar falhas de comunicação com o sistema RTO.
//
// Quando o RTO está fora do ar (não respondendo, timeout, gateway down)
// as mensagens técnicas do axios ("Network Error", "ECONNREFUSED", etc.)
// não ajudam o usuário final. Este helper detecta esses casos para que
// a UI substitua por uma mensagem orientativa.

export const RTO_UNREACHABLE_MESSAGE =
  'Não foi possível contatar o sistema RTO. Verifique se ele está em execução.';

// Retorna true quando o erro indica que o RTO está inacessível.
// NÃO inclui 4xx (que indicam que o RTO respondeu mas rejeitou a chamada).
// 500 normalmente é "erro de lógica" do RTO, mas QUANDO o proxy do PGDI não
// consegue abrir socket com o RTO ele também devolve 500 com a mensagem do
// .NET ("...máquina de destino as recusou ativamente...") — esse caso precisa
// ser tratado como unreachable.
const UNREACHABLE_PATTERNS = [
  /m[áa]quina de destino as recusou/i,    // pt-BR (.NET) socket refused
  /target machine actively refused/i,       // en-US (.NET) socket refused
  /ECONNREFUSED/i,
  /ETIMEDOUT/i,
  /No connection could be made/i,
  /Connection refused/i,
];

function bodyLooksUnreachable(data) {
  if (data == null) return false;
  const text = typeof data === 'string' ? data : JSON.stringify(data);
  return UNREACHABLE_PATTERNS.some(re => re.test(text));
}

export function isRtoUnreachableError(err) {
  if (!err) return false;
  // axios sem response = sem conexão (ECONNREFUSED, DNS, timeout, etc.)
  if (!err.response) return true;
  const code = err.code || '';
  if (code === 'ECONNREFUSED' || code === 'ETIMEDOUT' || code === 'ERR_NETWORK') return true;
  const status = err.response?.status;
  // 502/503/504 = gateway erro / serviço indisponível / gateway timeout.
  if (status === 502 || status === 503 || status === 504) return true;
  // 500 com payload tipico de socket refused (proxy do PGDI nao alcancou o RTO).
  if (status === 500 && bodyLooksUnreachable(err.response?.data)) return true;
  return false;
}

// Conveniência: devolve a mensagem genérica se for unreachable,
// caso contrário devolve o fallback informado.
export function rtoErrorMessage(err, fallback) {
  return isRtoUnreachableError(err) ? RTO_UNREACHABLE_MESSAGE : fallback;
}
